import { render, staticRenderFns } from "./creator-info.vue?vue&type=template&id=03dae576&scoped=true"
import script from "./creator-info.vue?vue&type=script&lang=js"
export * from "./creator-info.vue?vue&type=script&lang=js"
import style0 from "./creator-info.vue?vue&type=style&index=0&id=03dae576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dae576",
  null
  
)

export default component.exports